"use client";

/** Shared selector for the calculators - real routes (they must stay
 *  indexable URLs, matching the desktop Calculate dropdown + mobile
 *  sheet via the shared CALC_TABS).
 *
 *  Presentation: a segmented control with a SLIDING outlined thumb (the
 *  active outline glides to the tab you pick instead of teleporting)
 *  and an icon per calculator. On phones the old horizontally-scrolling
 *  pill strip hid whichever tabs were off-screen; it's a 2x2 grid now,
 *  so all four calculators are always visible and tappable. */
import { CALC_TABS } from "@/lib/nav-groups";
import PageTabs from "@/components/PageTabs";
import { BarChart3, Landmark, ReceiptText, BadgeCheck, Scale, PiggyBank } from "lucide-react";

// Order-matched to CALC_TABS: price, mortgage, sale-tax, eligibility.
// Keyed by route, not by position: a tab added to CALC_TABS without an
// icon here falls back to the bar chart instead of rendering `undefined`
// (which took every calculator page down with "Element type is invalid").
const TAB_ICONS: Record<string, typeof BarChart3> = {
  "/calculate": BarChart3,
  "/calculate/mortgage": Landmark,
  "/calculate/rent-vs-buy": Scale,
  "/calculate/affordability": PiggyBank,
  "/calculate/sale-tax": ReceiptText,
  "/calculate/eligibility": BadgeCheck,
};

export default function CalcNav() {
  return <PageTabs tabs={CALC_TABS} icons={TAB_ICONS} defaultHref="/calculate" />;
}
